"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayazaResponseStatus = exports.PayazaCallbackResponseType = void 0;
var PayazaCallbackResponseType;
(function (PayazaCallbackResponseType) {
    PayazaCallbackResponseType["ERROR"] = "error";
    PayazaCallbackResponseType["INFO"] = "info";
    PayazaCallbackResponseType["ACTION"] = "action";
    PayazaCallbackResponseType["ERROR_CLIENT"] = "error-client";
    PayazaCallbackResponseType["SUCCESS"] = "success";
})(PayazaCallbackResponseType = exports.PayazaCallbackResponseType || (exports.PayazaCallbackResponseType = {}));
var PayazaResponseStatus;
(function (PayazaResponseStatus) {
    PayazaResponseStatus[PayazaResponseStatus["SUCCESS"] = 201] = "SUCCESS";
    PayazaResponseStatus[PayazaResponseStatus["VALIDATION_ERROR"] = 400] = "VALIDATION_ERROR";
    PayazaResponseStatus[PayazaResponseStatus["MERCHANT_KEY_ERROR"] = 401] = "MERCHANT_KEY_ERROR";
    PayazaResponseStatus[PayazaResponseStatus["SERVER_ERROR"] = 500] = "SERVER_ERROR";
})(PayazaResponseStatus = exports.PayazaResponseStatus || (exports.PayazaResponseStatus = {}));
